export abstract class ActionOnObject {
  public readonly object;

  constructor(object) {
    if (!object) {
      throw new Error('object is not defined');
    }
    this.object = object;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/ActionOnObject.ts